module.exports = __webpack_public_path__ + "img/outils.b83c5341.jpg";